import dayjs from 'dayjs'

export const formatIsoToDe = (iso: string | null | undefined): string => {
  if (!iso) return ''
  const d = dayjs(iso, 'YYYY-MM-DD', true)
  return d.isValid() ? d.format('DD.MM.YYYY') : ''
}
